import { render, staticRenderFns } from "./CellRendererActions.vue?vue&type=template&id=1521a8fb&"
import script from "./CellRendererActions.vue?vue&type=script&lang=js&"
export * from "./CellRendererActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports